import { Component, Input } from "@angular/core";
import { CollectionPreview } from "@apiserver-rest/ponder-data-client-base";
import { PreviewItemComponent } from "@ponder-shared/previewItem/preview-item.component";
import { formatCurrency, formatCurrencyShorthand, formatNumber, formatNumberShorthand } from "@ponder-shared/utils/numberFormatter";
import { isMobileScreen } from "@ponder-shared/utils/screenBreakpoints";

@Component({
    selector: "collection-preview",
    imports: [PreviewItemComponent],
    templateUrl: "./collection-preview.component.html"
})
export class CollectionPreviewComponent {
    @Input({ required: true }) public username!: string;
    @Input({ required: true }) public collectionPreview!: CollectionPreview;

    public collectionUrl!: string;

    constructor() {

    }

    public ngOnInit(): void {
        this.collectionUrl = `/user/${this.username}/collection/${this.collectionPreview.game.toLowerCase()}`;
    }

    public getCardCount(): string {
        return `${(isMobileScreen() ? formatNumberShorthand(this.collectionPreview.total) : formatNumber(this.collectionPreview.total))} cards`;
    }

    public getDistinctCardCount(): string {
        return `${(isMobileScreen() ? formatNumberShorthand(this.collectionPreview.distinct) : formatNumber(this.collectionPreview.distinct))} distinct`;
    }

    public getTotalValue(): string {
        return isMobileScreen() ? formatCurrencyShorthand(this.collectionPreview.valueUSD) : formatCurrency(this.collectionPreview.valueUSD);
    }
}